<template>
	<jr-echarts ref="echartsRef" :options="chartOptions" :height="height" :width="width" />
</template>

<script>
	import JrEcharts from './index.vue'

	// 环形进度图组件
	export default {
		name: 'ProgressChart',
		components: {
			JrEcharts
		},
		props: {
			width: {
				type: String,
				default: '100%'
			},
			height: {
				type: String,
				default: '350px'
			},
			value: {
				type: Number,
				default: 80
			},
			title: {
				type: String,
				default: '较高'
			},
			subTitle: {
				type: String,
				default: '证件数量超过80%同类人'
			},
			color: {
				type: String,
				default: '#ff7849'
			}
		},
		data() {
			return {}
		},
		computed: {
			chartOptions() {
				return {
					series: [
						{
							type: 'gauge',
							startAngle: 180,
							endAngle: 0,
							center: ['50%', '68%'],
							radius: '100%',
							min: 0,
							max: 100,
							pointer: {
								show: false
							},
							progress: {
								show: true,
								overlap: false,
								roundCap: false, // 是否显示圆角
								clip: false,
								itemStyle: {
									color: this.color
								}
							},
							axisLine: {
								lineStyle: {
									width: 18,
									color: [[1, '#E6EBF8']]
								}
							},
							splitLine: {
								show: false
							},
							axisTick: {
								show: false
							},
							axisLabel: {
								show: false
							},
							title: {
								show: true,
								fontSize: 24,
								fontWeight: 'bold',
								color: this.color,
								offsetCenter: [0, '-10%'],
								fontFamily: 'Microsoft YaHei'
							},
							detail: {
								show: true,
								fontSize: 16,
								fontWeight: 'normal',
								color: '#666',
								offsetCenter: [0, '20%'],
								formatter: this.subTitle,
								fontFamily: 'Microsoft YaHei'
							},
							data: [
								{
									value: this.value,
									name: this.title
								}
							]
						}
					]
				}
			}
		},
		watch: {},
		created() {},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped></style>
